//
// Video Modal Functions
//
import { Fancybox } from "@fancyapps/ui";

export default class VideoModal {
  constructor() {

    Fancybox.bind("[data-fancybox]");

  }
}